<template>
  <div id="app">
    <navbar />
    <router-view />
    <footer-component />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import FooterComponent from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    FooterComponent
  },
  created() {
    // Cargar configuración inicial
    this.$store.dispatch('loadConfiguration')
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

router-view {
  flex: 1;
}
</style>